export const contact = {
  phone: '602-905-6398',
  email: 'admin@nextrealestate.team',
}

export const founder = {
  name: 'Phil Sexton',
  title: 'Founder',
  company: 'HomeSmart NEXT',
  image: 'https://cdn.magicpatterns.com/uploads/tefv9w5ABmnSj9kBc6vgoG/image.png',
  quote:
    "Lead generation and lead conversion has been my jam for the last 20 years and I'm very proud to have helped agents close nearly $3B in home sales here in the Valley. I built the NEXT team to be next style of team where we promote you and your brand instead of the team. I'd love to chat about working together.",
}

export const benefits = [
  {
    icon: 'brand',
    title: 'Your Brand, Your Business',
    body: 'Build your name, your local reputation, and your client relationships. NEXT supports the business you are creating instead of making you disappear behind a team brand.',
    featured: true,
  },
  {
    icon: 'automation',
    title: 'AI, Automation, and CRM Workflows',
    body: 'Create more consistent follow-up with lead routing, nurture workflows, reminders, tasks, campaign automation, and practical AI tools built for real estate.',
    featured: false,
  },
  {
    icon: 'marketing',
    title: 'Marketing That Works Around You',
    body: 'Get support with agent branding, social content, creative, campaigns, advertising, retargeting, and systems that help keep your marketing active.',
    featured: false,
  },
  {
    icon: 'operations',
    title: 'Operations, Data, and Real Estate Expertise',
    body: 'Get the benefit of leaders who understand brokerage operations, MLS data, technology, title and escrow, agent workflows, and the real estate business in Arizona.',
    featured: false,
  },
] as const

export const youKeep = [
  'Your name and personal brand',
  'Your client relationships',
  'Your market and business style',
  'Your goals and growth plan',
  'Your voice and local reputation',
]

export const nextRuns = [
  'Lead response and follow-up systems',
  'Marketing workflows and campaigns',
  'CRM, AI, and automation tools',
  'Technology, data, and MLS-powered resources',
  'Operational support and business strategy',
]

export const steps = [
  {
    title: 'Start With a Private Conversation',
    body: 'Tell us about your business, goals, market, and the parts of your business that feel harder than they should.',
  },
  {
    title: 'See the NEXT Support Model',
    body: 'Explore the tools, systems, marketing, operations, and practical support available to help you grow.',
  },
  {
    title: 'Build the Right Next Step',
    body: 'If there is a fit, create a clear plan that supports your brand, your clients, and the type of real estate business you want to build.',
  },
]

export const techProofPoints = [
  'Practical tools built around real agent workflows',
  'Automation that supports consistent client follow-up',
  'Data and systems designed by real estate operators',
]

export const testimonials = [
  {
    quote:
      'HomeSmart NEXT is the team I have always been looking for, they are focused on growing my business. I have already closed numerous deals from their marketing efforts.',
    name: 'Patty Labenske',
    detail: 'HomeSmart NEXT Agent',
  },
  {
    quote:
      'I knew what I should be doing, but didn\u2019t have the time to create the systems myself. NEXT gives me all the tools I need to stay in front of my clients.',
    name: 'Donna White',
    detail: 'HomeSmart NEXT Agent',
  },
  {
    quote:
      'I joined NEXT because I was tired of doing everything on my own. I love being part of a team that is always innovating.',
    name: 'Rob Miele',
    detail: 'HomeSmart NEXT Agent',
  },
]

export const credibilityBadges = [
  'Systems Built for Arizona',
  'Technology and Automation Focus',
  'Marketing Expertise',
  'Coaching',
]

export const priorityOptions = [
  'More consistent lead follow-up',
  'Better marketing and personal branding',
  'Technology and automation',
  'More leads or better conversion',
  'Operations and transaction support',
  'Business strategy and growth plan',
  'I am not sure yet',
]

export const faqs = [
  {
    question: 'Is HomeSmart NEXT a traditional real estate team?',
    answer:
      'No. NEXT is designed to help agents build their own business and personal brand while gaining access to stronger systems, technology, marketing support, automation, and operational resources behind the scenes.',
  },
  {
    question: 'Will I lose my personal brand?',
    answer:
      'No. Your name, reputation, client relationships, and local market presence matter. NEXT is built to help agents strengthen their individual brand rather than disappear behind a team identity.',
  },
  {
    question: 'Who is a good fit for NEXT?',
    answer:
      'Arizona agents who want to grow with better systems, more consistent follow-up, stronger marketing, practical technology, and knowledgeable operational support can be a strong fit.',
  },
  {
    question: 'Do I need to be a high-producing agent?',
    answer:
      'No. The right fit depends more on your goals, your willingness to build a more intentional business, and whether the NEXT support model fits the way you want to grow.',
  },
  {
    question: 'What happens after I submit the form?',
    answer:
      'A HomeSmart NEXT team member will reach out for a private, no-pressure conversation about your business, goals, and the type of support that may be useful.',
  },
]

export const navLinks = [
  { label: 'How NEXT Works', href: '#how-it-works' },
  { label: 'Agent Support', href: '#agent-support' },
  { label: 'Technology', href: '#technology' },
]

export const images = {
  hero: 'https://cdn.magicpatterns.com/uploads/oZ6eFLG3N5s45xWg5cTcpm/generated-image_(24).png',
  workflow: 'https://cdn.magicpatterns.com/uploads/mtAZLYjXkEBMniHpHJwgkc/generated-image_(36).png',
  team: 'https://cdn.magicpatterns.com/uploads/5EdLWDa1e9CDSyaAGJEn7G/generated-image_(35).png',
}
